import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

export function PageHeader({
  title,
  description,
  actions,
  className,
  eyebrow,
}: {
  title: string
  description?: string
  actions?: ReactNode
  className?: string
  eyebrow?: string
}) {
  return (
    <div className={cn('admin-page-header', className)}>
      <div className="admin-page-heading">
        {eyebrow && <span>{eyebrow}</span>}
        <h1>{title}</h1>
        {description && (
          <p>{description}</p>
        )}
      </div>
      {actions && <div className="admin-page-actions">{actions}</div>}
    </div>
  )
}

export function PageSection({
  title,
  children,
  className,
}: {
  title?: string
  children: ReactNode
  className?: string
}) {
  return (
    <section className={cn('space-y-4', className)}>
      {title && (
        <h2 className="text-xs font-semibold uppercase tracking-widest text-[#93a5ad]">{title}</h2>
      )}
      {children}
    </section>
  )
}
